import apiClient from '../client';
import { ApiResponse } from '../types/common.types';
import {
  DueLoan,
  PaymentReminderRequest,
  CollectionActionRequest,
  CollectionAction,
  DueLoansQueryParams,
} from '../types/collection.types';

/**
 * Collections API endpoints
 */
export const collectionsApi = {
  /**
   * Get due loans
   */
  getDueLoans: async (params?: DueLoansQueryParams): Promise<DueLoan[]> => {
    const response = await apiClient.get<ApiResponse<{ dueLoans: DueLoan[] }>>(
      '/collections/due',
      { params }
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data.dueLoans;
  },

  /**
   * Send payment reminder
   */
  sendReminder: async (data: PaymentReminderRequest): Promise<{ reminderSent: boolean; sentAt: string }> => {
    const response = await apiClient.post<ApiResponse<{ reminderSent: boolean; sentAt: string }>>(
      '/collections/send-reminder',
      data
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data;
  },

  /**
   * Log collection action
   */
  logAction: async (data: CollectionActionRequest): Promise<{ success: boolean }> => {
    const response = await apiClient.post<ApiResponse>('/collections/log-action', data);
    return { success: response.data.success };
  },

  /**
   * Get collection history
   */
  getHistory: async (customerId: string): Promise<CollectionAction[]> => {
    const response = await apiClient.get<ApiResponse<{ actions: CollectionAction[] }>>(
      `/collections/actions/${customerId}`
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data.actions;
  },
};
